import { Routes, Route } from 'react-router-dom';
import LiffLayout from './layouts/LiffLayout';
import Home from './pages/Home';

function LiffApp() {
  return (
    <Routes>
      <Route path="/" element={<LiffLayout />}>
        <Route index element={<Home />} />
        <Route path="*" element={<div>Page Not Found</div>} />
      </Route>
    </Routes>
  );
}

export default LiffApp;
